import ArrowUpRight from "Assets/Icons/ArrowUpRightIcon";
import DownArrowIcon from "Assets/Icons/DownArrowIcon";
import EditAttendanceIcon from "Assets/Icons/EditAttendanceIcon";
import EditSmallIcon from "Assets/Icons/EditSmallIcon";
import EyeIcon from "Assets/Icons/EyeIcon";
import { Dropdown, Menu, Space, Tooltip, Button as ANTDButton } from "antd";
import MeetLinkIcon from "Assets/Icons/MeetLinkIcon";
import MeetLinkIconDisable from "Assets/Icons/MeetLinkIconDisable";
import NotMarkedIcon from "Assets/Icons/NotMarkedIcon";
import UpArrowIcon from "Assets/Icons/UpArrowIcon";
import CustomModal from "Components/CommonComponents/CustomModal";
import Typography from "Components/CommonComponents/Typography";
import { ToastContextDispatch, UserInfoContext } from "Context/CommonContext";
import useMasterContext from "Context/MasterContext";
import PDFPageviewer from "Pages/PlannerView/PDFPageviewer";
import { RenderItem } from "Pages/SyllabusCompliance/CoveredSyllabusView";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Col, Collapse, Row } from "reactstrap";
import styled from "styled-components";
import {
  BASE_URL,
  GetViewDocumentURL,
  GET_CONTENT_LICENCE,
} from "utilFunctions/Constants/urlConstants";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import { convertTime } from "utilFunctions/helperFunctions/convertTime";
import {
  inBetweenTime,
  ScheduleStatus,
  ScheduleStatusColor,
} from "utilFunctions/shared/ScheduleStatus";
import { format, setHours, setMinutes, setSeconds, subDays } from "date-fns";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import {
  CLASS_URL_ENCODE_STRING,
  UPLOAD_ASSET_LASTDATE,
} from "utilFunctions/Constants/Constants";
import { Buffer } from "buffer";
import CrystalLink from "Assets/Icons/CrystalLink";
import VideoPlayer from "Pages/AssetView/VideoPlayer";
import { DownOutlined, UploadOutlined } from "@ant-design/icons";
import ErrorView from "Pages/AssetView/ErrorView";
import moment from "moment";
// import UploadFileDrawer from "Components/UploadFileDrawer"; // Import the new component
import UploadAssetDrawer from "Components/UploadAssetDrawer";
import { UserRoles } from "utilFunctions/Constants/UserRoles";
import useViewAccess from "Pages/MySchedule/Hooks/useViewAccess";
// import AssetViewerModal from "Components/AssetViewerModal";

interface IScheduledLectureCardView {
  cardData?: any;
  screen?: any;
  cardIndex?: any;
  handleJoinLecture?: any;
  handleMarkSyllbus?: any;
  mode?: any;
  buttonCSS?: any;
  detailShowHandler?: any;
  totalCards?: number;
  dateRanges?: any;
  filterState?: any;
}
const ScheduleDiv: any = styled<any>("div")`
  background-color #fff;
  display:flex;
  width: ${({ mode, screen }: any) =>
    ["dashboard"].includes(mode)
      ? ["xs", "sm", "md"].includes(screen)
        ? "100%"
        : "100%"
      : ["schedule"].includes(mode) && ["xs", "sm", "md"].includes(screen)
      ? "100%"
      : "100%"};
  border: 1px solid #cccccc;
  border-radius: 5px;
  border-left: 8px solid ${({ color }: any) => color};
  padding: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "16px" : "16px"};
  margin-bottom: 12px;
  flex-direction: column;
`;
const MainDiv: any = styled<any>("div")`
  background-color #fff;
  display:flex;
  flex-direction: ${({ mode, screen, totalCards }: any) =>
    ["dashboard"].includes(mode)
      ? totalCards > 1
        ? "column"
        : ["xs", "sm", "md"].includes(screen)
        ? "column"
        : "row"
      : ["schedule"].includes(mode) && ["xs", "sm", "md"].includes(screen)
      ? "column"
      : "row"};
  width: 100%;
  gap: 16px;
`;
const Div1: any = styled<any>("div")`
  width: 100%;
  white-space: nowrap;
`;
const Div2: any = styled<any>("div")`
  width: 100%;
  display: flex;
  justify-content: end;
  align-items: center;
`;
const HeadingDiv: any = styled<any>("div")`
  font-weight: 700;
  font-size: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "14px" : "16px"};
  color: #333333;
`;
const HeadingDiv1: any = styled<any>("div")`
  display: flex;
  justify-content: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "space-between" : ""};
  margin-bottom: 4px;
`;
const SubHeadingDiv: any = styled<any>("div")`
  font-weight: 400;
  font-size: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "12px" : "14px"};
  color: #757575;
`;
const StyledDropdown = styled(Dropdown)`
  .ant-dropdown-menu-item {
    padding: 15px !important;
  }
  .ant-dropdown-menu-submenu-title {
    padding: 15px !important;
  }
`;
function ScheduledLectureCard({
  cardData,
  screen,
  cardIndex,
  handleMarkSyllbus,
  mode,
  buttonCSS,
  detailShowHandler,
  totalCards,
  dateRanges,
  filterState,
}: IScheduledLectureCardView) {
  const ToastDispatch = useContext(ToastContextDispatch);
  const { masters } = useMasterContext();
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const { isViewOnly } = useViewAccess({
    UserRoleAccess: [UserRoles.academicCounsellor],
  });
  const navigate = useNavigate();
  const [pdfPassword, setPdfPassword] = useState<string | null>(null);
  const [isOpenCollapse, setisOpenCollapse] = useState<boolean>(false);
  const [isPaneOpen, setIsPaneOpen] = useState<boolean>();
  const [pdfUrl, setPdfUrl] = useState<string>("");
  const [assetViewOpen, setAssetViewOpen] = useState<boolean>(false);
  const [contentType, setContentType] = useState<any>(null);
  const [items, setItems] = useState<any>([]);
  const [open, setOpen] = useState<boolean>(false);

  const handleUploadFile = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const onUploadSuccess = (data: any) => {
    console.log("File uploaded successfully:", data);
  };

  const cardViewData = cardData;
  console.log("cardViewData", cardViewData);
  const { makeRequest: GetViewDocument } = useGetApi(
    (data: any) => {
      if (data && data["detailMessage"]) {
        setIsPaneOpen(!isPaneOpen);
        setPdfUrl(data["detailMessage"]);
      }
    },
    (error: any) => {
      setPdfUrl("");
      if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["internalCode"] &&
        error["response"]["data"]["internalCode"] != "1008"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    }
  );
  useEffect(() => {
    if (cardData && cardData.lectureContent && cardData.lectureContent.ebooks) {
      const arr = cardData.lectureContent.ebooks.map(
        (ele: any, index: number) => {
          const arr = ele?.url?.split("/");
          const fileName = arr[arr.length - 1];
          return {
            key: index + 1,
            label: fileName,
            url: ele?.url,
            client: ele?.client,
          };
        }
      );
      setItems(arr);
    }
  }, [cardData]);
  const returnDisableHandler = (cardViewData: any) => {
    let retValue = true;
    if (cardViewData?.eventLink && cardViewData.eventType == "DEMO CLASS") {
      retValue = false;
    } else if (cardViewData.courseId && cardViewData.courseId != null) {
      retValue = false;
    } else {
      if (cardViewData.eventLink) {
        retValue = false;
      }
      retValue = true;
    }
    return retValue;
  };
  const getViewDocumentHandler = (cardViewData: any) => {
    GetViewDocument(
      BASE_URL + GetViewDocumentURL + "?s3Key=" + cardViewData.documentS3Key
    );
  };
  const handleMarkAttendance = (data: any, type: any) => {
    if (data) {
      navigate("/admin/schedule/attendance/" + data.batchTimeTableId, {
        replace: false,
        state: {
          referrer: location.pathname,
          selectedSchedule: data,
          attendanceStatus: type,
          courseId: data?.courseId,
          dateRanges,
          filterState,
        },
      });
    } else {
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message: "CourseId not present",
      });
    }
  };

  const mnEncodeBase64 = (data: any) => {
    const key = CLASS_URL_ENCODE_STRING;
    let temp: any = Buffer.from(data).toString("base64");
    const mapObj: { [key: string]: string } = {
      "+": "@",
      "/": "$",
      "=": "!",
      "&": "^",
      "?": "#",
    };

    for (const key in mapObj) {
      if (Object.prototype.hasOwnProperty.call(mapObj, key)) {
        while (temp.indexOf(key) !== -1) {
          temp = temp.replace(key, mapObj[key]);
        }
      }
    }
    return key + temp;
  };
  function processEventLink(input: string | null, substring: string): any {
    if (!input || input.trim() === "" || !input.includes(substring)) {
      return input;
    }

    const splitOnQuestionMark = input.split("?");
    if (splitOnQuestionMark.length !== 2) {
      return null;
    }

    const roomId = splitOnQuestionMark[1].split("=");
    if (roomId.length !== 2) {
      return null;
    }

    const isPresenter = "1";
    const encId = mnEncodeBase64(
      roomId[1] + "_" + userInfo.employeeId + "_" + `${isPresenter}` + "_1"
    );

    return splitOnQuestionMark[0] + `/${encId}`;
  }
  const { makeRequest: fetchFileDecryptionKey } = useGetApi(
    (data: any) => {
      if (data?.detailMessage) {
        const decodedKey = atob(data?.detailMessage);
        setPdfPassword(decodedKey);
      } else {
        setPdfPassword("NO_PASSWORD");
      }
    },
    (error: any) => {
      setPdfPassword("NO_PASSWORD");
      console.error(error);
    }
  );

  const onClickViewPdf: any = ({ key }: any) => {
    setAssetViewOpen(true);
    const data = items.find((ele: any) => ele.key == key);
    fetchFileDecryptionKey(
      BASE_URL +
        GET_CONTENT_LICENCE +
        `?assetId=${cardViewData.batchTimeTableId}&courseId=${cardViewData?.courseId}&source=${data?.client}`
    );
    setContentType({
      type: "ebook",
      data: data?.url,
      client: data?.client,
    });
  };
  // const dateViewDatas = cardViewData?.endTime.split("T")[0];
  const dateViewDatas = moment(cardViewData?.endTime)
    .utcOffset("+05:30")
    .format()
    .split("T")[0];
  const todayDates = moment().utcOffset("+05:30").format().split("T")[0];
  const past7Days = format(
    setSeconds(setMinutes(setHours(subDays(new Date(), 5), 18), 30), 0),
    "yyyy-MM-dd"
  );
  const time = moment(cardViewData?.endTime);
  const checkValidation = () => {
    let retVal = false;
    if (userInfo?.fexRole == "Faculty" && dateViewDatas == todayDates) {
      retVal = false;
    } else if (
      userInfo?.fexRole != "Faculty" &&
      (time.isBetween(past7Days, todayDates) || dateViewDatas == todayDates)
    ) {
      retVal = false;
    } else {
      retVal = true;
    }
    return retVal;
  };

  return (
    <>
      <UploadAssetDrawer
        open={open}
        onClose={onClose}
        onUploadSuccess={onUploadSuccess}
        BASE_URL={BASE_URL}
        lectureId={cardViewData?.batchTimeTableId}
        courseId={cardViewData?.courseId}
      />
      <ScheduleDiv
        key={cardIndex}
        color={ScheduleStatusColor(
          inBetweenTime(cardViewData?.startTime, cardViewData?.endTime)
            ? "Ongoing"
            : cardViewData.syllabusStatus
        )}
        screen={screen}
        mode={mode}
      >
        <CustomModal
          modal={isPaneOpen}
          centered={true}
          backdrop={true}
          size={"xl"}
          fullscreen={true}
          toggle={() => {
            setIsPaneOpen(false);
            setPdfUrl("");
          }}
        >
          <PDFPageviewer
            allPageInOne={true}
            pdfUrl={pdfUrl}
            isLibraryView={true}
          />
        </CustomModal>
        {/* <AssetViewerModal
          isOpen={assetViewOpen} // Replace with the state controlling the modal visibility
          onClose={() => {
            setAssetViewOpen(false);
          }} // Replace with the function to close the modal
          contentType={contentType} // Replace with the content type (video or ebook)
          pdfPassword={pdfPassword} // Replace with the PDF password if applicable
          title={
            contentType
              ? contentType.type == "video"
                ? cardViewData.eventName + " Video"
                : cardViewData.eventName + " PDF"
              : " "
          } // Replace with the title for the modal
          assetId={cardViewData.batchTimeTableId} // Replace with the asset ID if applicable
        /> */}
        <CustomModal
          modal={assetViewOpen}
          centered={true}
          backdrop={true}
          size={contentType && contentType.type == "video" ? "lg" : "xl"}
          fullscreen={true}
          title={
            contentType
              ? contentType.type == "video"
                ? cardViewData.eventName + " Video"
                : cardViewData.eventName + " PDF"
              : " "
          }
          toggle={() => {
            setAssetViewOpen(false);
          }}
        >
          <div className="w-100 d-flex p-3 align-items-center justify-content-center">
            {contentType ? (
              contentType.type == "video" ? (
                <VideoPlayer
                  videoUrl={contentType.data}
                  JWTToken={""}
                  assetId={cardViewData.batchTimeTableId}
                  source={contentType.client}
                ></VideoPlayer>
              ) : contentType?.data != "" && pdfPassword != null ? (
                <PDFPageviewer
                  allPageInOne={true}
                  pdfUrl={contentType?.data}
                  pdfPassword={pdfPassword}
                  isLibraryView={true}
                  source={contentType.client}
                />
              ) : (
                <ErrorView />
              )
            ) : null}
          </div>
        </CustomModal>
        <MainDiv mode={mode} screen={screen} totalCards={totalCards}>
          <Div1>
            {" "}
            <HeadingDiv1 screen={screen}>
              <div className="d-flex">
                <HeadingDiv screen={screen}>
                  <span className="pr-2">
                    {convertTime(cardViewData?.startTime, "h:mm")} -
                  </span>
                  <span>
                    {convertTime(cardViewData?.endTime, "h:mm a")} |&nbsp;
                  </span>
                </HeadingDiv>
                <HeadingDiv screen={screen}>
                  <Tooltip title={cardViewData?.eventType}>
                    <span>
                      {cardViewData.eventName
                        ? cardViewData.eventName
                        : cardViewData.eventType}
                    </span>
                  </Tooltip>
                </HeadingDiv>
              </div>
              <div className="cardStatusChip">
                <ScheduleStatus
                  status={
                    inBetweenTime(
                      cardViewData?.startTime,
                      cardViewData?.endTime
                    )
                      ? "Ongoing"
                      : cardViewData?.syllabusStatus &&
                        cardViewData?.syllabusStatus != null &&
                        cardViewData?.syllabusStatus.toUpperCase() == "NA"
                      ? ""
                      : cardViewData?.syllabusStatus &&
                        cardViewData?.syllabusStatus != null
                      ? cardViewData.syllabusStatus
                      : ""
                  }
                ></ScheduleStatus>
              </div>
            </HeadingDiv1>
            <div className="d-flex">
              <SubHeadingDiv screen={screen}>
                {cardViewData.batchName} |&nbsp;
              </SubHeadingDiv>
              <SubHeadingDiv screen={screen}>{cardViewData.room}</SubHeadingDiv>
            </div>
          </Div1>
          <Div2>
            <div className="d-flex w-100 justify-content-end">
              {cardViewData.syllabusStatus == "Upcoming" ? (
                <div className="d-flex flex-row">
                  {!isViewOnly &&
                    cardViewData?.eventLink &&
                    cardViewData?.eventLink != null && (
                      <Button
                        outline
                        size="sm"
                        disabled={returnDisableHandler(cardViewData)}
                        color={
                          returnDisableHandler(cardViewData)
                            ? "aeslDraft"
                            : "aeslPrimary"
                        }
                        onClick={() =>
                          window.open(
                            processEventLink(
                              cardViewData?.eventLink,
                              "crystal"
                            ),
                            "_blank"
                          )
                        }
                        className={`${buttonCSS} no-hover-effect buttonHeight`}
                      >
                        {["PTM", "ORIENTATION"].includes(
                          cardViewData.eventType
                        ) ? (
                          <>Join meeting </>
                        ) : (
                          <>Join lecture </>
                        )}
                        {returnDisableHandler(cardViewData) ? (
                          <MeetLinkIconDisable id="UncontrolledTooltipMeetlink"></MeetLinkIconDisable>
                        ) : cardViewData?.eventLink != null &&
                          cardViewData?.eventLink.includes("crystal") ? (
                          <CrystalLink id="UncontrolledTooltipMeetlink" />
                        ) : (
                          <MeetLinkIcon id="UncontrolledTooltipMeetlink" />
                        )}
                      </Button>
                    )}
                </div>
              ) : cardViewData.syllabusStatus == "Marked" ? (
                <div className="d-flex flex-row">
                  {cardViewData &&
                  ["LECTURE", "EXTRA CLASS", "DOUBT CLASS"].includes(
                    cardViewData.eventType
                  ) &&
                  cardViewData?.takeAttendance ? (
                    cardViewData.attendanceStatus == "Unmarked" ? (
                      <Button
                        outline
                        size="sm"
                        color="aeslPrimary"
                        onClick={() => {
                          handleMarkAttendance(cardViewData, "mark");
                        }}
                        className={`${buttonCSS} no-hover-effect buttonHeight no-button-border`}
                      >
                        {!checkValidation()
                          ? "Take Attendance"
                          : "View Attendance"}
                        &nbsp;
                        <EditSmallIcon />
                      </Button>
                    ) : (
                      <Button
                        outline
                        size="sm"
                        color="aeslPrimary"
                        onClick={() => {
                          handleMarkAttendance(cardViewData, "edit");
                        }}
                        className={`${buttonCSS} no-hover-effect buttonHeight no-button-border`}
                      >
                        {!checkValidation()
                          ? "Edit Attendance"
                          : "View Attendance"}
                        &nbsp;
                        <EditAttendanceIcon />
                      </Button>
                    )
                  ) : null}
                  {!isViewOnly && cardViewData?.markLecture && (
                    <Button
                      outline
                      size="sm"
                      color={
                        returnDisableHandler(cardViewData)
                          ? "aeslDraft"
                          : "aeslPrimary"
                      }
                      disabled={returnDisableHandler(cardViewData)}
                      onClick={() => {
                        handleMarkSyllbus(cardViewData, "view");
                      }}
                      className={`${buttonCSS} no-hover-effect buttonHeight`}
                    >
                      View Syllabus <EyeIcon />
                    </Button>
                  )}
                </div>
              ) : cardViewData.syllabusStatus == "Unmarked" ||
                inBetweenTime(
                  cardViewData?.startTime,
                  cardViewData?.endTime
                ) ? (
                <div className="d-flex flex-row">
                  {cardViewData &&
                  ["LECTURE", "EXTRA CLASS", "DOUBT CLASS"].includes(
                    cardViewData.eventType
                  ) &&
                  cardViewData?.takeAttendance ? (
                    cardViewData.attendanceStatus == "Unmarked" ? (
                      <Button
                        outline
                        size="sm"
                        color="aeslPrimary"
                        onClick={() => {
                          handleMarkAttendance(cardViewData, "mark");
                        }}
                        className={`${buttonCSS} no-hover-effect buttonHeight no-button-border`}
                      >
                        {!checkValidation()
                          ? "Take Attendance"
                          : "View Attendance"}
                        &nbsp;
                        <EditSmallIcon />
                      </Button>
                    ) : (
                      <Button
                        outline
                        size="sm"
                        color="aeslPrimary"
                        onClick={() => {
                          handleMarkAttendance(cardViewData, "edit");
                        }}
                        className={`${buttonCSS} no-hover-effect buttonHeight no-button-border`}
                      >
                        {!checkValidation()
                          ? "Edit Attendance"
                          : "View Attendance"}
                        &nbsp;
                        <EditAttendanceIcon />
                      </Button>
                    )
                  ) : null}
                  {!isViewOnly &&
                    new Date(new Date()) < new Date(cardViewData?.endTime) &&
                    cardViewData?.eventLink &&
                    cardViewData?.eventLink != null && (
                      <Button
                        outline
                        size="sm"
                        color={"aeslPrimary"}
                        onClick={() =>
                          window.open(
                            processEventLink(
                              cardViewData?.eventLink,
                              "crystal"
                            ),
                            "_blank"
                          )
                        }
                        className={`${buttonCSS} no-hover-effect buttonHeight`}
                      >
                        Join lecture&nbsp;
                        {cardViewData?.eventLink != null &&
                        cardViewData?.eventLink.includes("crystal") ? (
                          <CrystalLink id="UncontrolledTooltipMeetlink" />
                        ) : (
                          <MeetLinkIcon id="UncontrolledTooltipMeetlink" />
                        )}
                      </Button>
                    )}

                  {inBetweenTime(
                    cardViewData?.startTime,
                    cardViewData?.endTime
                  ) ? null : !isViewOnly && cardViewData?.markLecture ? (
                    <Button
                      outline
                      size="sm"
                      color={
                        returnDisableHandler(cardViewData)
                          ? "aeslDraft"
                          : "aeslPrimary"
                      }
                      disabled={returnDisableHandler(cardViewData)}
                      onClick={() => {
                        handleMarkSyllbus(cardViewData, "mark");
                      }}
                      className={`${buttonCSS} no-hover-effect buttonHeight`}
                    >
                      Mark Syllabus{" "}
                      <NotMarkedIcon
                        color={
                          returnDisableHandler(cardViewData) ? "#757575" : ""
                        }
                      />
                    </Button>
                  ) : null}
                </div>
              ) : (
                <div className="d-flex flex-row">
                  {cardViewData &&
                  ["LECTURE", "EXTRA CLASS", "DOUBT CLASS"].includes(
                    cardViewData.eventType
                  ) &&
                  cardViewData?.takeAttendance ? (
                    cardViewData.attendanceStatus == "Unmarked" ? (
                      <Button
                        outline
                        size="sm"
                        color="aeslPrimary"
                        onClick={() => {
                          handleMarkAttendance(cardViewData, "mark");
                        }}
                        className={`${buttonCSS} no-hover-effect buttonHeight no-button-border`}
                      >
                        {!checkValidation()
                          ? "Take Attendance"
                          : "View Attendance"}
                        &nbsp;
                        <EditSmallIcon />
                      </Button>
                    ) : (
                      <Button
                        outline
                        size="sm"
                        color="aeslPrimary"
                        onClick={() => {
                          handleMarkAttendance(cardViewData, "edit");
                        }}
                        className={`${buttonCSS} no-hover-effect buttonHeight no-button-border`}
                      >
                        {!checkValidation()
                          ? "Edit Attendance"
                          : "View Attendance"}
                        &nbsp;
                        <EditAttendanceIcon />
                      </Button>
                    )
                  ) : null}
                </div>
              )}
            </div>

            {mode && mode != "dashboard" && (
              <div
                className="ml-3 cursor-pointer d-flex algn-items-center"
                onClick={() => {
                  setisOpenCollapse(!isOpenCollapse);
                }}
              >
                {isOpenCollapse ? <UpArrowIcon /> : <DownArrowIcon />}
              </div>
            )}
          </Div2>
        </MainDiv>
        {mode && mode != "dashboard" && (
          <div>
            <Collapse isOpen={isOpenCollapse} className="scheduledCollapseCard">
              <Row>
                <Col
                  sm={6}
                  xs={12}
                  md={6}
                  className={
                    ["xs", "sm", "md"].includes(screen)
                      ? "lecColScheduledLecture"
                      : ""
                  }
                >
                  <div className="d-flex flex-column capitalize">
                    <Typography variant="label" color="black">
                      {"Batch"}
                    </Typography>
                    <span
                      className="filterSpan"
                      onClick={() => {
                        navigate("/admin/mybatch/" + cardViewData.batchId, {
                          replace: false,
                        });
                      }}
                    >
                      {cardViewData?.batchName}
                    </span>
                  </div>
                </Col>

                <Col
                  sm={6}
                  xs={12}
                  md={6}
                  className="d-flex justify-content-end align-items-center"
                >
                  {cardViewData.lectureContent != null && (
                    <div className="d-flex justify-content-evenly gap-3 pl-4">
                      {!isViewOnly &&
                      cardViewData &&
                      cardViewData.lectureContent &&
                      cardViewData.lectureContent.videos &&
                      cardViewData.lectureContent.videos.length ? (
                        <span
                          className="filterSpan"
                          onClick={() => {
                            setAssetViewOpen(true);
                            setContentType({
                              type: "video",
                              data:
                                cardViewData.lectureContent.videos &&
                                cardViewData.lectureContent.videos.length &&
                                cardViewData.lectureContent.videos[0]?.url,
                              client:
                                cardViewData.lectureContent.videos &&
                                cardViewData.lectureContent.videos.length &&
                                cardViewData.lectureContent.videos[0]?.client,
                            });
                          }}
                        >
                          View Lecture recording
                        </span>
                      ) : null}
                      {!isViewOnly &&
                      cardViewData &&
                      cardViewData.lectureContent &&
                      cardViewData.lectureContent.ebooks &&
                      cardViewData.lectureContent.ebooks.length ? (
                        <span className="filterSpan">
                          <StyledDropdown
                            overlay={
                              <Menu
                                items={items}
                                onClick={onClickViewPdf}
                                style={{ padding: "12px" }}
                              />
                            }
                            placement="top"
                          >
                            <a onClick={(e) => e.preventDefault()}>
                              <Space>
                                View Lecture PDF
                                <DownOutlined />
                              </Space>
                            </a>
                          </StyledDropdown>
                        </span>
                      ) : null}
                    </div>
                  )}
                  {cardViewData?.syllabusStatus == "Upcoming" ||
                  (cardViewData.lectureContent != null &&
                    cardViewData?.lectureContent?.videos &&
                    cardViewData.lectureContent.videos.some(
                      (item: any) => item.client === "CRYSTAL"
                    )) ||
                  new Date(cardViewData?.endTime) <
                    new Date(UPLOAD_ASSET_LASTDATE) ||
                  inBetweenTime(
                    cardViewData?.startTime,
                    cardViewData?.endTime
                  ) ||
                  ["DEMO CLASS", "PTM", "ORIENTATION"].includes(
                    cardViewData?.eventType
                  ) ? null : (
                    <Tooltip title="Upload lecture assets">
                      <ANTDButton
                        size="large"
                        type="link"
                        disabled={isViewOnly}
                        icon={
                          <UploadOutlined
                            style={{
                              fontSize: "18px",
                              color: isViewOnly ? "gray" : "#008dc4",
                            }}
                          />
                        }
                        onClick={() => handleUploadFile()}
                      ></ANTDButton>
                    </Tooltip>
                  )}
                </Col>
              </Row>
              <Row className="mt-3">
                <Col
                  xs={6}
                  sm={3}
                  md={3}
                  className={
                    ["xs", "sm", "md"].includes(screen)
                      ? "lecColScheduledLecture"
                      : ""
                  }
                >
                  <RenderItem
                    label={"Class"}
                    value={cardViewData?.class}
                    masters={masters}
                  />
                </Col>
                <Col
                  xs={6}
                  sm={3}
                  md={3}
                  className={
                    ["xs", "sm", "md"].includes(screen)
                      ? "lecColScheduledLecture"
                      : ""
                  }
                >
                  <RenderItem
                    label={"Room"}
                    value={cardViewData?.room}
                    masters={masters}
                  />
                </Col>
                {cardViewData?.subject && (
                  <Col
                    xs={6}
                    sm={3}
                    md={3}
                    className={
                      ["xs", "sm", "md"].includes(screen)
                        ? "lecColScheduledLecture"
                        : ""
                    }
                  >
                    <RenderItem
                      label={"Subject"}
                      value={
                        cardViewData?.subject
                          ? cardViewData.subject.charAt(0).toUpperCase() +
                            cardViewData.subject.slice(1).toLowerCase()
                          : ""
                      }
                      masters={masters}
                    />
                  </Col>
                )}
                <Col>
                  {!isViewOnly && (
                    <div className="d-flex flex-column capitalize">
                      <Typography variant="label" color="black"></Typography>
                      <span
                        className="filterSpan mt-2"
                        onClick={() => {
                          detailShowHandler(cardData);
                        }}
                      >
                        View Library <ArrowUpRight></ArrowUpRight>
                      </span>
                    </div>
                  )}
                </Col>
                {cardViewData.documentS3Key && (
                  <Col>
                    <div className="d-flex flex-column capitalize">
                      <Typography variant="label" color="black"></Typography>
                      <span
                        className="filterSpan mt-2"
                        onClick={() => {
                          getViewDocumentHandler(cardViewData);
                        }}
                      >
                        View Document <ArrowUpRight></ArrowUpRight>
                      </span>
                    </div>
                  </Col>
                )}
              </Row>
            </Collapse>
          </div>
        )}
      </ScheduleDiv>
    </>
  );
}

export default ScheduledLectureCard;
